var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundReportsActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4974 18.9584H7.4974C2.9724 18.9584 1.03906 17.0251 1.03906 12.5001V7.50008C1.03906 2.97508 2.9724 1.04175 7.4974 1.04175H11.6641C12.0057 1.04175 12.2891 1.32508 12.2891 1.66675C12.2891 2.00841 12.0057 2.29175 11.6641 2.29175H7.4974C3.65573 2.29175 2.28906 3.65841 2.28906 7.50008V12.5001C2.28906 16.3417 3.65573 17.7084 7.4974 17.7084H12.4974C16.3391 17.7084 17.7057 16.3417 17.7057 12.5001V8.33341C17.7057 7.99175 17.9891 7.70841 18.3307 7.70841C18.6724 7.70841 18.9557 7.99175 18.9557 8.33341V12.5001C18.9557 17.0251 17.0224 18.9584 12.4974 18.9584Z",
    fill: "#610D24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3307 8.95816H14.9974C12.1474 8.95816 11.0391 7.84983 11.0391 4.99983V1.66649C11.0391 1.41649 11.1891 1.18316 11.4224 1.09149C11.6557 0.991494 11.9224 1.04983 12.1057 1.22483L18.7724 7.89149C18.9474 8.06649 19.0057 8.34149 18.9057 8.57483C18.8057 8.80816 18.5807 8.95816 18.3307 8.95816ZM12.2891 3.17483V4.99983C12.2891 7.14983 12.8474 7.70816 14.9974 7.70816H16.8224L12.2891 3.17483Z",
    fill: "#610D24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundReportsActiveIcon);
export default __webpack_public_path__ + "static/media/fundReports_active_icon.7b060992e2e1d6f8f56c42b5709bda3e.svg";
export { ForwardRef as ReactComponent };